import { Backdrop, Box, Button, Checkbox, CircularProgress, Divider, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Radio, RadioGroup, Snackbar, Stack, TextField, Typography } from '@mui/material'
import Select from 'react-select';
import React, { useRef, forwardRef, useState } from 'react'
import customStyles from 'app/shared-components/SelectCustomStyle'
import QuestionListIcon from 'src/assets/question-list.png'
import { FastForwardOutlined } from '@mui/icons-material';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import OAuthService from 'src/app/auth/services/oAuthService';
import { useEffect } from 'react';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { useImperativeHandle } from 'react';
import jwtDecode from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import AgGridTable from '../utilities/AgGridTable';

const RETMOUQuestinaries = forwardRef((props, ref) => {
    const dsTask = JSON.parse(localStorage.getItem('dsTask'));
    const backAction = localStorage.getItem('backAction')
    const token = localStorage.getItem('token');
    const navigate = useNavigate()
    const formRef = useRef();
    const [partnerOptions, setPartnerOptions] = useState()
    const [partnerId, setPartnerId] = useState();
    const [partnerName, setPartnerName] = useState();
    const [dataObj, setDataObj] = useState()
    const [showroomId, setShowroomId] = useState();
    const [showroomName, setShowroomName] = useState();
    const [showroomOptions, setShowroomOptions] = useState()
    const [showroomQuestions, setShowroomQuestions] = useState()
    const [editData, setEditData] = useState()
    const [dsTaskAssignmentFiles, setDsTaskAssignmentFiles] = useState([])
    const [sitePhotos, setSitePhotos] = useState([])
    const [drawings, setDrawings] = useState([])
    const [allFilesImages, setAllFilesImages] = useState([])
    const [checkedData, setCheckedData] = useState([])
    const [loading, setLoading] = useState(false)
    const [backdropOpen, setBackdropOpen] = useState(false)
    const [checkStatus, setCheckStatus] = useState(true);
    const [successMsg, setSuccessMsg] = useState();
    const [openSnack, setOpenSnack] = useState(false);
    const [rowData, setRowData] = useState();
    const gridRef = useRef();
    const [productId, setProductId] = useState([]);
    const [range1Id, setRange1Id] = useState([]);
    const [range2Id, setRange2Id] = useState([]);
    const [addedRows, setAddedRows] = useState([]);

    const params = dsTask ? { ...props, id: dsTask?.dsTaskId } : props;

    useEffect(() => {
        params?.checkedStatus(checkStatus)
    }, [checkStatus])

    const shrQuestionnaires = async () => {
        try {
            setLoading(true);
            setBackdropOpen(true);
            const dsQuestonnariesUrl = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsQuestionnaires}`;
            const dsShmQuestionnaires = await OAuthService.getList(`${dsQuestonnariesUrl}/search/findByDesignStudioCategory?designStudioCategory=MOU`)

            const result = dsShmQuestionnaires?.data?._embedded?.dsQuestionnaires?.map((value) => {
                return { ...value, quesId: value.quesId, question: value.question, options: value.options, fieldType: value.dsUiComphonent }
            })
            setShowroomQuestions(result)
            setLoading(false);
            setBackdropOpen(false)
        } catch (error) {
            setLoading(false)
            console.log(error, "error")
        }
    }
    const partners = async () => {
        const decode = jwtDecode(token);
        const findAllByAreaManagerUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.territoryList}/search/findAllByAreaManagerContains?email=${decode.email}`;
        const areaManager = await OAuthService.getList(findAllByAreaManagerUrl);
        const areaManagerId = areaManager?.data?._embedded?.territories[0]?.id

        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}/search/findByTerritoryAndActive?territory=${areaManagerId}&active=true`;
        const partners = await OAuthService.getList(url);

        const result = partners?.data?._embedded?.companies.map((value) => {
            return { label: `${value?._links.company.href.split('/').pop()} ${value.name}`, value: value.name, id: value?._links.company.href.split('/').pop() }
        })
        setPartnerOptions(result);
    }

    const showrooms = async () => {
        if (partnerId) {
            const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom}/showroomsByCompanyNum?companyNum=${partnerId}&size=100`;
            const showrooms = await OAuthService.getList(url);

            const result = showrooms?.data?.result?.map((value) => {
                return { label: `${value.id} ${value.text}`, value: value.text, id: value?.id }
            })
            setShowroomOptions(result);
        }
    }

    const handleShowroomChange = (data) => {
        setShowroomId(data.id);
        setShowroomName(data.value);
        setEditData({ ...editData, showroom: data.value })
    };
    const handlePartnerChange = async (data) => {
        setPartnerName(data.value);
        setPartnerId(data.id);
        setEditData({ ...editData, partner: data.value })
    };

    useEffect(() => {
        shrQuestionnaires();
        partners();
    }, [])

    useEffect(() => {
        showrooms()
        setShowroomId()
    }, [partnerId])

    useEffect(() => {
        if (editData) {
            const editFn = async () => {

                const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom}/showroomsByCompanyNum?companyNum=${partnerId || editData?.partnerId}&size=100`;
                const showrooms = await OAuthService.getList(url);

                const result = showrooms?.data?.result?.map((value) => {
                    return { label: `${value.id} ${value.text}`, value: value.text, id: value?.id }

                })
                setShowroomOptions(result);
            }
            editFn()
        }
    }, [editData])

    useEffect(() => {
        if (backAction == true || backAction == "true") {
            if (dsTask) {
                setEditData(dsTask)
                setDataObj(dsTask && dsTask.dsQuestionnaires && dsTask.dsQuestionnaires)
                setShowroomQuestions(dsTask && dsTask.dsQuestionnaires && dsTask.dsQuestionnaires)
            }
        }
    }, [backAction])

    const uploadFiles = async (data, btnType) => {
        // const allFileImages = allFilesImages.flat();
        const dsTaskFiles = dsTaskAssignmentFiles ? [...dsTaskAssignmentFiles] : []
        const dsTaskSitePhotos = sitePhotos ? [...sitePhotos] : []
        const dsTaskDrawings = drawings ? [...drawings] : []
        const formData = new FormData();

        dsTaskFiles.forEach((file) => formData.append('files', file))
        dsTaskSitePhotos.forEach((file) => formData.append('sitePhotos', file))
        dsTaskDrawings.forEach((file) => formData.append('drawings', file))

        await OAuthService.addFiles(`${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsUploadMultipleFiles}?dsTaskId=${data?.dsTaskId}&category=${data?.designStudioCategory}&updatedBy=${data.modifiedByUser}`, formData)
            .then((response) => {
                if (btnType === 'draft') {
                    navigate('/design-studio/request-list')
                } else {
                    localStorage.setItem('dsTask', JSON.stringify(response.data))
                }
            }).catch((err) => console.log(err, "uploadFiles"))
    }

    const handleSaveDraft = async () => {
        const decode = jwtDecode(token);
        let model = {
            ...editData,
            partnerId: partnerId || editData?.partnerId,
            partner: partnerName || editData?.partner,
            showroomId: showroomId || editData?.showroomId,
            showroom: showroomName || editData?.showroom,
            dsQuestionnaires: showroomQuestions || editData?.dsQuestionnaires,
            designStudioCategory: editData?.designStudioCategory || props.designStudioCategory,
            isDsLifeCyclePassForNextState: false,
            isDsStatusPassForNextState: false,
            createdByUser: decode.email,

        }

        try {
            if (params?.id || dsTask) {
                await OAuthService.putData(`${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignment}/${params.id || dsTask?.dsTaskId}`, model)
                    .then((res) => {
                    })
                    .catch((err) => console.log(err));
                uploadFiles(model, "draft")
                navigate('/design-studio/request-list')

            } else {
                await OAuthService.addData(`${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignment}`, model).then(async (res) => {
                    if (res.data) {
                        uploadFiles(res.data, 'draft')

                    }
                    navigate('/design-studio/request-list')

                });
            }
        } catch (error) {
            console.log(error, "error")
            // setError(error.message)
            return;
        }
    }

    const handleSubmit = async () => {
        // setCheckStatus(true)
        const decode = jwtDecode(token);
        let model = {
            ...editData,
            partnerId: partnerId || editData?.partnerId,
            partner: partnerName || editData?.partner,
            showroomId: showroomId || editData?.showroomId,
            showroom: showroomName || editData?.showroom,
            dsQuestionnaires: showroomQuestions || editData?.dsQuestionnaires,
            designStudioCategory: editData?.designStudioCategory || props.designStudioCategory,
            isDsLifeCyclePassForNextState: false,
            isDsStatusPassForNextState: false,
            createdByUser: decode.email,
            createdDate: new Date(),
            kitchenQuantities: rowData,
        }

        console.log('model', model)
        console.log('addedRows', addedRows)
        console.log('rowDate', rowData)

        try {
            if (params?.id) {
                // const data = { ...model, isDsStatusPassForNextState: true }
                await OAuthService.putData(`${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignment}/${params.id}`, model)
                    .then(async (res) => {
                    })
                    .catch((err) => console.log(err));
                uploadFiles(model, 'submit')

                setSuccessMsg("Data updated SuccessFully.");
                setOpenSnack(true);
                navigate('/new-request-calendar');
                return "Data updated SuccessFully.";
            } else {
                await OAuthService.addData(`${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignment}`, model).then(async (res) => {
                    if (res.data) {
                        localStorage.setItem('dsTask', JSON.stringify(res.data))
                        uploadFiles(res.data, 'submit')
                    }
                    navigate('/new-request-calendar')

                });
            }
            // setSuccessMsg("Data Saved SuccessFully.");
            // setOpenSnack(true);
        } catch (error) {
            console.log(error, "error")
            // setError(error.message)
            return;
        }
    }

    useEffect(() => {
        params.checkedStatus(checkStatus)
    }, [checkStatus])

    useImperativeHandle(ref, () => ({
        handleSubmit: handleSubmit,
        handleSaveDraft: handleSaveDraft
    }))

    const handleDocumentChange = (e) => {
        setAllFilesImages(allFilesImages && [...allFilesImages, Array.from(e.target.files)])
        setDsTaskAssignmentFiles(e.target.files);

    }

    const handleSitePhotosChange = (e) => {
        setAllFilesImages(allFilesImages && [...allFilesImages, Array.from(e.target.files)])
        setSitePhotos(e.target.files);
    }

    const handleDrawingChange = (e) => {
        setAllFilesImages(allFilesImages && [...allFilesImages, Array.from(e.target.files)])
        setDrawings(e.target.files);
    }

    useEffect(() => {
        if (showroomQuestions) {
            if (params?.id || dsTask) {
                const data = showroomQuestions.every((ele) => ele.answer != null || ele?.answer != "" || (ele.answer && ele.comment != null || ele.answer && ele.comment != ''))
                if (data == true && partnerName && showroomName && qty && (dsTaskAssignmentFiles != null || dsTaskAssignmentFiles?.length > 0) && (sitePhotos != null || sitePhotos?.length > 0) && (drawings != null || drawings?.length > 0)) {
                    setCheckStatus(false)
                } else {
                    setCheckStatus(true)
                }
            } else {
                // for (let i = 0; i < showroomQuestions.length; i++) {
                //     if (partnerId == undefined || partnerName == undefined || showroomId == undefined ||  showroomName == undefined || sitePhotos.length == 0 || drawings.length == 0 || dsTaskAssignmentFiles.length == 0 || showroomQuestions[i].answer == null) {
                //         setCheckStatus(true)
                //     } else {
                //         setCheckStatus(false)
                //     }
                // }

                const data = showroomQuestions.every((ele) => ele.answer != null || (ele.answer && ele.comment != null))
                if (data == true && partnerName && showroomName && qty && dsTaskAssignmentFiles.length > 0 && sitePhotos.length > 0 && drawings.length > 0) {
                    setCheckStatus(false)
                } else {
                    setCheckStatus(true)
                }
            }
        }
    }, [showroomQuestions, dsTaskAssignmentFiles, sitePhotos, drawings, partnerId, partnerName, showroomId, showroomName])

    const editDsTask = async () => {
        const url = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignment}/${params?.id}`;
        const result = await OAuthService.getList(url);
        setDataObj(result.data.dsQuestionnaires)
        setShowroomQuestions(result.data.dsQuestionnaires)
        setEditData(result.data)
        setDsTaskAssignmentFiles(result.data.dsTaskAssignmentFiles)
        setSitePhotos(result.data.sitePhotosFiles)
        setDrawings(result.data.drawingsFiles)
        setPartnerId(result.data.partnerId)
        setPartnerName(result.data.partner)
        setShowroomId(result.data.showroomId)
        setShowroomName(result.data.showroom)
        // localStorage.setItem('dsTask', JSON.stringify(result.data))
    }

    useEffect(() => {
        if (params?.id) {
            editDsTask();
        }
    }, [params?.id])

    const handleRadioChange = (e, data) => {
        const updatedValue = { ...data, answer: e.target.value }
        const updated = updateShrQuestions(updatedValue)
        setShowroomQuestions(updated)
    }
    const updateComment = (e, data) => {
        const updatedValue = { ...data, comment: e.target.value }
        const updated = updateShrQuestions(updatedValue)
        setShowroomQuestions(updated)
    }

    const handleCheckbox = (e, data) => {
        const { value, checked } = e.target
        setDataObj(data)
        if (checked) {
            setCheckedData((prevValues) => [...prevValues, value])
        } else {
            setCheckedData((prevValues) => prevValues.filter((data) => data !== value))
        }
    }

    useEffect(() => {
        if (dataObj) {
            const updatedValue = { ...dataObj, answer: checkedData?.join(',') }
            const updated = updateShrQuestions(updatedValue)
            setShowroomQuestions(updated)
        }
    }, [checkedData, dataObj])

    useEffect(() => {
        if (dataObj) {
            if (dataObj[0] || dataObj[7]) {
                const d = (dataObj[0] || dataObj[7]).answer?.split(",")
                setCheckedData(checkedData?.concat(d))
            }
        }
    }, [dataObj])

    const updateShrQuestions = (updatedValue) => {
        const foundIndex = showroomQuestions.findIndex(x => x?.quesId == updatedValue?.quesId)
        if (foundIndex != -1) {
            const updatedQuestions = [...showroomQuestions]
            updatedQuestions[foundIndex] = updatedValue
            return updatedQuestions
        }
        return showroomQuestions
    }

    const handleSnackClose = (e) => {
        setOpenSnack(false)
    }

    const handleRemoveFile = (index, name, type) => {
        if (type === 'files') {
            setDsTaskAssignmentFiles([...dsTaskAssignmentFiles].filter((_, i) => i !== index));
        } else if (type === 'sitePhoto') {
            setSitePhotos([...sitePhotos].filter((_, i) => i !== index))
        } else if (type === 'drawings') {
            setDrawings([...drawings].filter((_, i) => i !== index))
        }
        setAllFilesImages(allFilesImages.flat().filter((obj) => (obj.name || obj?.fileName) !== name))
    }

    const [qty, setQty] = useState();

    const handleQtyChange = (event) => {
        const inputValue = event.target.value;
        if (!isNaN(inputValue)) {
            const numberValue = parseFloat(inputValue);
    
            if (numberValue >= 1 && numberValue <= 10) {
                setQty(numberValue.toString());
            }
        }
        const newData = [];
        for (let i = 0; i < event.target.value; i++) {
          newData.push({
            layoutName: '',
            product: '',
            range1: '',
            priceGroup: '',
            front1: '',
            carcass: '',
            range2: '',
            priceGroup2: '',
            front2: '',
            carcass2: '',
            scheme: '',
            handleConcept: '',
            handle1: '',
            handle2: '',
            drawerAccFinish: '',
            drawerType: '',
            antiStpMat: '',
            lightings: '',
            sinkAccsseories: '',
            workTops: '',
            plinths: '',
            remarks: '',
          });
        }
        setRowData(newData);
    }

    const factoryVendorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;
    // const findAllProductUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllProduct}`;
    // const rangeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findRangeByVendor}`;
    // const priceGroupUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.priceGroup}`;

    const SelectProduct = forwardRef((props, ref) => {
      const { data, colDef } = props;
      const refVendor = useRef();
      const [error, setError] = useState("");
      const [vendors, setVendors] = useState([]);
      const [selectedVendor, setSelectedVendor] = useState(null);
  
      const getVendorsList = async () => {
        OAuthService.getList(factoryVendorUrl + `?size=1000`)
          .then((list) => {
            const { factoryVendors } = list.data?._embedded;
            const activeVender = factoryVendors.filter((item) => item.active);
            setVendors(
              activeVender?.map((vendor) => ({
                label: vendor.name,
                value: vendor.id,
              }))
            );
            console.log('activeVender', activeVender, vendors)
            console.log('factoryVendors', factoryVendors)
            console.log('colDef', data[colDef.field])

            
            const vendor = factoryVendors.filter(
              (vendor) => console.log(vendor.name, data[colDef.field], vendor.name === data[colDef.field])
            );
            console.log('vendor', vendor, data[colDef.field])
            if (vendor.length > 0)
              setSelectedVendor({ value: vendor[0].id, label: vendor[0].name });
          })
          .catch((err) => setError(err.message));
      };
  
      const handleVendorChange = (value) => {
        if (!value) return;
        data.productId = value.value;
        props.node.setData(data);
        setSelectedVendor(value);
        // setOpenCom(false);
      };
  
      useEffect(() => {
        getVendorsList();
      }, []);
  
      useImperativeHandle(ref, () => {
        return {
          getValue() {
            return selectedVendor?.label;
          },
        };
      });
  
      return (
        <div className="w-full" style={{ width: 200 }}>
          <Select
            className="basic-multi-select mb-4"
            name="name"
            required
            ref={refVendor}
            value={selectedVendor}
            onChange={handleVendorChange}
            options={vendors}
            styles={customStyles()}
          />
        </div>
      );
    });
  
    const SelectRange = forwardRef((props, ref) => {
      const { data, colDef, node } = props;
      const refRange = useRef();
      const [range, setRange] = useState([]);
      const [selectedRange, setSelectedRange] = useState(null);
      const [allItems, setAllItems] = useState([]);
  
      if (!productId) return;
      const getRangeList = async () => {
        if (!data.product) {
          alert("Please select a product first");
          return;
        }
  
        const rangeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findRangeByVendor}`;
        const list = await OAuthService.getList(`${rangeUrl}?vendorId=${data.productId}`);
        const ranges = list.data?._embedded?.ranges;
  
        setAllItems(ranges);
        setRange(
          ranges.map((range) => ({
            value: range.id,
            label: range.productName,
          }))
        );
        
        return ranges.map((range) => ({
          value: range.id,
          label: range.productName,
        }));
      };
  
      const handleRangeChange = (value) => {
        if (!value) return;
  
        const priceUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ranges}`;
  
        const selectedRange = allItems.filter(
          (item) => item.id === value.value
        )[0];
  
        const priceGroupId = selectedRange.id
        OAuthService.getList(`${priceUrl}/${priceGroupId}/priceGroup`)
        .then((list) => {
          if (colDef.field === "range1"){
            data.priceGroup = list.data.pgId;
          } else if (colDef.field === "range2") {
            data.priceGroup2 = list.data.pgId;
          }
        })
        .catch((err) => setError(err.message));  
        data.range1Id = value.value;
        props.node.setData(data);
        setSelectedRange(value);
      };
  
      useEffect(() => {
        getRangeList();
      }, []);
  
      useImperativeHandle(ref, () => {
        return {
          getValue() {
            return selectedRange?.label;
          },
        };
      });
  
      return (
        <div className="w-full" style={{ width: 200 }}>
          <Select
            className="basic-multi-select mb-4"
            name="name"
            required
            ref={refRange}
            value={selectedRange}
            onChange={handleRangeChange}
            options={range}
            styles={customStyles()}
          />
        </div>
      );
    });
  
    const SelectCarCass = forwardRef((props, ref) => {
      const { data, colDef } = props;
      const refCarCass = useRef();
      const [carCass, setCarCass] = useState([]);
      const [selectedCarCass, setSelectedCarCass] = useState(null);
      const [allItems, setAllItems] = useState([]); 
  
      if (!productId) return;
      const getCarCassList = async () => {
        if (!data.product) {
          alert("Please select a product first");
          return;
        }
        const carcassUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllCarcassByVendor}`;
        const list = await OAuthService.getList(`${carcassUrl}?vendorId=${data.productId}`);
        console.log('carcasses', list, data.productId)
        const carcasses = list.data?._embedded?.carcasses;
  
        setCarCass(
          carcasses.map((product) => ({
            value: `${product.productId} ${product.productName}`,
            label: `${product.productId} ${product.productName}`,
          }))
        );
  
        return carcasses.map((product) => ({
          value: `${product.productId} ${product.productName}`,
          label: `${product.productId} ${product.productName}`,
        }))
      };
  
      const handleCarCassChange = (value) => {
        if (!value) return;
        setSelectedCarCass(value);
      };
  
      useEffect(() => {
        getCarCassList();
      }, []);
  
      useImperativeHandle(ref, () => {
        return {
          getValue() {
            return selectedCarCass?.label;
          },
        };
      });
  
      return (
        <div className="w-full" style={{ width: 200 }}>
          <Select
            className="basic-multi-select mb-4"
            name="name"
            required
            ref={refCarCass}
            value={selectedCarCass}
            onChange={handleCarCassChange}
            options={carCass}
            styles={customStyles()}
          />
        </div>
      );
    });
  
    const SelectFront = forwardRef((props, ref) => {
      console.log('Front Color', props)
      const { data, colDef } = props;
      const refFront = useRef();
      const [front, setFront] = useState([]);
      const [selectedFront, setSelectedFront] = useState(null);
      
      if (!range1Id) return;
      const getFrontList = async () => {
        if (!data.range1) {
          alert("Please select a range first");
          return;
        }
        const colorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ranges}`;
        const data1 = { materialStatus: "true" };
        const list = await OAuthService.getList(`${colorUrl}/${data.range1Id}/variations`);
        const rangeVariations = list.data?._embedded?.rangeVariations;
        
        setFront(
          rangeVariations.map((product) => ({
            value: `${product.productId} ${product.productName}`,
            label: `${product.productId} ${product.productName}`,
          }))
        );
        
        return rangeVariations.map((product) => ({
          value: `${product.productId} ${product.productName}`,
          label: `${product.productId} ${product.productName}`,
        }))
      };
  
      const handleFrontChange = (value) => {
        if (!value) return;
        setSelectedFront(value);
      };
  
      useEffect(() => {
        getFrontList();
      }, []);
  
      useImperativeHandle(ref, () => {
        return {
          getValue() {
            return selectedFront?.label;
          },
        };
      });
  
      return (
        <div className="w-full" style={{ width: 200 }}>
          <Select
            className="basic-multi-select mb-4"
            name="name"
            required
            ref={refFront}
            value={selectedFront}
            onChange={handleFrontChange}
            options={front}
            styles={customStyles()}
          />
        </div>
      );
    });
  
    const SelectHandle = forwardRef((props, ref) => {
      const { data, colDef } = props;
      const refHandle = useRef();
      const [handle, setHandle] = useState([]);
      const [selectedHandle, setSelectedHandle] = useState(null);
  
      const getHandleList = async () => {
        const handleUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllHandlesByVendor}`;
        const list = await OAuthService.getList(`${handleUrl}?vendorId=${data.productId}`);
        const handles = list.data?._embedded?.handles;
  
        setHandle(
          handles.map((product) => ({
            value: `${product.productId} ${product.productName}`,
            label: `${product.productId} ${product.productName}`,
          }))
        );
        
        return handles.map((product) => ({
          value: `${product.productId} ${product.productName}`,
          label: `${product.productId} ${product.productName}`,
        }))
      };
  
      const handleHandleChange = (value) => {
        if (!value) return;
        setSelectedHandle(value);
      };
  
      useEffect(() => {
        getHandleList();
      }, []);
  
      useImperativeHandle(ref, () => {
        return {
          getValue() {
            return selectedHandle?.label;
          },
        };
      });
  
      return (
        <div className="w-full" style={{ width: 200 }}>
          <Select
            className="basic-multi-select mb-4"
            name="name"
            required
            ref={refHandle}
            value={selectedHandle}
            onChange={handleHandleChange}
            options={handle}
            styles={customStyles()}
          />
        </div>
      );
    });

    const [columnDefs, setColumnDefs] = useState([
      { field: "layoutName", enableRowGroup: true, minWidth: 200 },
      { field: "product", enableRowGroup: true, minWidth: 200, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectProduct },
      { field: "range1", enableRowGroup: true, minWidth: 200, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectRange, },
      { field: "priceGroup", enableRowGroup: true, minWidth: 200, },
      { field: "front1", enableRowGroup: true, minWidth: 200, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectFront, },
      { field: "carcass", enableRowGroup: true, minWidth: 200, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectCarCass, },
      { field: "range2", enableRowGroup: true, minWidth: 200, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectRange, },
      { field: "priceGroup2", enableRowGroup: true, minWidth: 200, },
      { field: "front2", enableRowGroup: true, minWidth: 200, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectFront, },
      { field: "carcass2", enableRowGroup: true, minWidth: 200, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectCarCass, },
      { field: "scheme", enableRowGroup: true, minWidth: 200, },
      { field: "handleConcept", enableRowGroup: true, minWidth: 200, },
      { field: "handle1", enableRowGroup: true, minWidth: 200, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectHandle, },
      { field: "handle2", enableRowGroup: true, minWidth: 200, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectHandle, },
      { field: "drawerAccFinish", enableRowGroup: true, minWidth: 200, },
      { field: "drawerType", enableRowGroup: true, minWidth: 200, },
      { field: "antiStpMat", enableRowGroup: true, minWidth: 200, },
      { field: "lightings", enableRowGroup: true, minWidth: 200, },
      { field: "sinkAccsseories", enableRowGroup: true, minWidth: 200, },
      { field: "workTops", enableRowGroup: true, minWidth: 200, },
      { field: "plinths", enableRowGroup: true, minWidth: 200, },
      { field: "remarks", enableRowGroup: true, minWidth: 200,},
    ]);

    const onRowValueChanged = async (event) => {
      const { rowIndex, data } = event.node;
      const tempAddedRows = [...addedRows];
      tempAddedRows[rowIndex] = data;
      setAddedRows(tempAddedRows);
    };

    return (
      <>
        <div className="w-full">
          <div>
            <FormControl ref={formRef} className="flex flex-col justify-center">
              <Grid
                container
                spacing={2}
              >
                <Grid item xs={5}>
                  <Stack>
                    <label>Select Partner</label>
                    <Select
                      value={
                        editData &&
                        partnerOptions &&
                        partnerOptions?.filter((obj) =>
                          editData.partner?.includes(obj.value)
                        )
                      }
                      options={partnerOptions}
                      styles={customStyles()}
                      className="select mt-10"
                      getOptionValue={(option) => `${option["id"]}`}
                      onChange={handlePartnerChange}
                    />
                  </Stack>
                </Grid>
                  <Grid item xs={4}>
                    <Stack>
                      <label>Select Showroom</label>
                      <Select
                        value={
                          editData &&
                          showroomOptions &&
                          showroomOptions?.filter((obj) =>
                            editData.showroom?.includes(obj.value)
                          )
                        }
                        options={showroomOptions}
                        styles={customStyles()}
                        className="select mt-10"
                        getOptionValue={(option) => `${option["id"]}`}
                        onChange={handleShowroomChange}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={3}>
                    <Stack>
                      <label>QTY</label>
                      <TextField
                        className='mt-10'
                        type="number"
                        name="qty"
                        value={qty}
                        onChange={handleQtyChange}
                        variant="outlined"
                      />
                    </Stack>
                  </Grid>
              </Grid>
              <Grid display="flex" className="mb-20 mt-20 ">
                <img src={QuestionListIcon} alt="" className="h-40 w-40" />
                <Typography className="text-3xl font-semibold ml-20">
                  Questionnaire
                </Typography>
              </Grid>
              <Divider className="mb-20 " />
              {loading ? (
                <Backdrop
                  sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={backdropOpen}
                >
                  <CircularProgress color="inherit" />
                  <Typography>Please wait while the data loads.</Typography>
                </Backdrop>
              ) : (
                <div>
                    <FormControl>
                    {(showroomQuestions && showroomQuestions)?.map(
                        (value, i) => (
                          <div>
                            <FormLabel>{`${i + 1}. ${value.question}`}</FormLabel>
                            <div className='flex items-center mb-16'>
                            {(value?.fieldType || value?.dsUiComphonent) ===
                              "RADIO" && (
                              <RadioGroup
                                row
                                className="questions"
                                value={value?.answer}
                                onChange={(e) =>
                                  handleRadioChange(e, value)
                                }
                              >
                                {value?.options?.map((obj, i) => {
                                  return (
                                    <FormControlLabel
                                      className="questions"
                                      value={obj}
                                      control={<Radio />}
                                      label={obj}
                                      key={i}
                                    />
                                  );
                                })}
                              </RadioGroup>
                            )}
                            {(value.quesId === 17 ||
                                value.quesId === 18 ||
                                value.quesId === 19 ||
                                value.quesId === 20 ||
                                value.quesId === 21) && (
                                  <TextField
                                    type="text"
                                    className="w-1/2"
                                    value={value?.comment || ""}
                                    onChange={(e) => updateComment(e, value)}
                                    placeholder="If yes, comment is mandatory"
                                  />
                              )}
                              </div>
                          </div>
                        )
                      )}
                  </FormControl>
                  {qty && <div className='h-full' style={{ height: '300px'}}>
                  <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridRef={gridRef}
                    hideCheckbox={true}
                    onCellValueChanged={onRowValueChanged}
                  />
                </div>}
                </div>
              )}
              <Divider className="mb-20 mt-10" />
              <Grid container spacing={2}>
              <Grid item xs={4}>
                  <Stack className="w-full mb-16">
                    <label>Site photos</label>
                    <Box
                      className="flex justify-center items-center mt-10"
                      sx={{
                        height: 95,
                        border: "1px dotted #FFFFFF",
                      }}
                    >
                      <CloudUploadOutlinedIcon fontSize={"large"} />
                      <Typography className="ml-12 text-xs">
                        Upload your files here or
                      </Typography>
                      <Button
                        variant="outlined"
                        component="label"
                        color="warning"
                        className="ml-12 w-96"
                      >
                        <input
                          hidden
                          multiple
                          type="file"
                          onChange={(e) => handleSitePhotosChange(e)}
                        />
                        <Typography color="#FFA726">Browse</Typography>
                      </Button>
                    </Box>
                    <div>
                      {sitePhotos &&
                        [...sitePhotos]?.map((obj, i) => (
                          // <div>{obj?.name}</div>
                          <ul>
                            <li key={i}>
                              {obj?.name || obj?.fileName}
                              <Button
                                onClick={() =>
                                  handleRemoveFile(
                                    i,
                                    obj?.name || obj?.fileName,
                                    "sitePhoto"
                                  )
                                }
                              >
                                <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                              </Button>
                            </li>
                          </ul>
                        ))}
                    </div>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Stack className="w-full mb-16">
                    <label>Drawings DWG OR DRW</label>
                    <Box
                      className="flex justify-center items-center mt-10"
                      sx={{
                        height: 95,
                        border: "1px dotted #FFFFFF",
                      }}
                    >
                      <CloudUploadOutlinedIcon fontSize={"large"} />
                      <Typography className="ml-12 text-xs">
                        Upload your files here or
                      </Typography>
                      <Button
                        variant="outlined"
                        component="label"
                        color="warning"
                        className="ml-12 w-96"
                      >
                        <input
                          hidden
                          multiple
                          type="file"
                          onChange={(e) => handleDrawingChange(e)}
                        />
                        <Typography color="#FFA726">Browse</Typography>
                      </Button>
                    </Box>
                    <div>
                      {drawings &&
                        [...drawings]?.map((obj, i) => (
                          // <div>{obj?.name}</div>
                          <ul>
                            <li key={i}>
                              {obj?.name || obj?.fileName}
                              <Button
                                onClick={() =>
                                  handleRemoveFile(
                                    i,
                                    obj?.name || obj?.fileName,
                                    "drawings"
                                  )
                                }
                              >
                                <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                              </Button>
                            </li>
                          </ul>
                        ))}
                    </div>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Stack className="w-full mb-16">
                    <label>Appliances details</label>
                    <Box
                      className="flex justify-center items-center mt-10"
                      sx={{
                        height: 95,
                        border: "1px dotted #FFFFFF",
                      }}
                    >
                      <CloudUploadOutlinedIcon fontSize={"large"} />
                      <Typography className="ml-12 text-xs">
                        Upload your files here or
                      </Typography>
                      <Button
                        variant="outlined"
                        component="label"
                        color="warning"
                        className="ml-12 w-96"
                      >
                        <input
                          hidden
                          multiple
                          type="file"
                          onChange={(e) => handleDocumentChange(e)}
                        />
                        <Typography color="#FFA726">Browse</Typography>
                      </Button>
                    </Box>
                    <div>
                      {dsTaskAssignmentFiles &&
                        [...dsTaskAssignmentFiles]?.map((obj, i) => (
                          // <div>{obj?.name}</div>
                          <ul>
                            <li key={i}>
                              {obj?.name || obj?.fileName}
                              <Button
                                onClick={() =>
                                  handleRemoveFile(
                                    i,
                                    obj?.name || obj?.fileName,
                                    "files"
                                  )
                                }
                              >
                                <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                              </Button>
                            </li>
                          </ul>
                        ))}
                    </div>
                  </Stack>
                </Grid>
              </Grid>
            </FormControl>
          </div>
        </div>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={openSnack}
          //   autoHideDuration={6000}
          onClose={handleSnackClose}
          message={successMsg}
          action={
            <>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleSnackClose}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </>
          }
        />
      </>
    );
})

export default RETMOUQuestinaries